<template>
  <div v-if="starters_items.length" class="main_event_info_widget">
    <div class="info_row">
      <span class="img"><img src="../assets/img/subtract.svg" aria-hidden="true" alt="list style"></span>
      <span class="conv_starters">{{$t(`ConversationStartersWidget['Conversation starters']`)}}</span>
    </div>
    <div
        v-for="item of starters_items"
        class="info_row list_item">
      <span class="img"><img src="../assets/img/ellipse-list.svg" aria-hidden="true" alt="list style"></span>
      <span>{{ item }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['event'],
  computed: {
    starters_items() {
      if (!this.event || !this.event.conversation_starters || !this.event.conversation_starters.length) {
        return [];
      }
      return this.event.conversation_starters.split('\n').filter(Boolean)
    }
  },
  name: "ConversationStartersWidget"
}
</script>

<style lang="scss" scoped>

.main_event_info_widget {
  .list_item {
    align-items: flex-start;

    span.img {
      padding: 8px;
    }
  }
}
</style>
